module.exports = __webpack_public_path__ + "media/images/icons/youtube_black-78888e5820309da89c141d0e7bb9ff03.svg";